import { format } from 'date-fns';
import { RequestStatusEnum } from '../enums/request-status.enum';
import { CompanyStatus } from '../interfaces/company.interface';

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ');
};

export const formatDate = (value?: Date | string | null): string =>
  value ? format(new Date(value), 'dd-LL-y') : '-';

export const formatDateWithTime = (value?: Date | string | null): string =>
  value ? format(new Date(value), 'dd-LL-y HH:mm') : '-';

export const RequestStatusMarkerColorMapper = {
  [RequestStatusEnum.NEW]: 'bg-sky-300',
  [RequestStatusEnum.IN_PROGRESS]: 'bg-yellow-800',
  [RequestStatusEnum.TO_DELIVER]: 'bg-green-800',
  [RequestStatusEnum.FINISHED]: 'bg-gray-800',
};

export const RequestStatusBackgroundColorMapper = {
  [RequestStatusEnum.NEW]: 'bg-sky-100',
  [RequestStatusEnum.IN_PROGRESS]: 'bg-yellow-200',
  [RequestStatusEnum.TO_DELIVER]: 'bg-indigo-300',
  [RequestStatusEnum.FINISHED]: 'bg-green-400',
};

export const CompanyStatusMarkerColorMapper = {
  [CompanyStatus.ACTIVE]: 'bg-green-500',
  [CompanyStatus.INACTIVE]: 'bg-gray-300',
};

export const CompanyStatusBackgroundColorMapper = {
  [CompanyStatus.ACTIVE]: 'bg-green-200',
  [CompanyStatus.INACTIVE]: 'bg-gray-100',
};

export const ClientStatusMarkerColorMapper = {
  [CompanyStatus.ACTIVE]: 'bg-green-500',
  [CompanyStatus.INACTIVE]: 'bg-gray-300',
};

export const ClientStatusBackgroundColorMapper = {
  [CompanyStatus.ACTIVE]: 'bg-green-200',
  [CompanyStatus.INACTIVE]: 'bg-gray-100',
};

export const ProfileStatusMarkerColorMapper = {
  [CompanyStatus.ACTIVE]: 'bg-green-500',
  [CompanyStatus.INACTIVE]: 'bg-gray-300',
};

export const ProfileStatusBackgroundColorMapper = {
  [CompanyStatus.ACTIVE]: 'bg-green-200',
  [CompanyStatus.INACTIVE]: 'bg-gray-100',
};
